import {GOLOS_NARODA_WIDGET_TYPES} from './constants';

const appendChildForGolosNarodaWidget = container => {
  if (!container) {
    return;
  }

  const element = document.createElement('div');

  element.setAttribute('data-type', GOLOS_NARODA_WIDGET_TYPES.DEFAULT);
  element.setAttribute('id', 'golos-naroda-widget');

  container.appendChild(element);
};

export {appendChildForGolosNarodaWidget};
